import { render, staticRenderFns } from "./categoryTab.vue?vue&type=template&id=a03ad406&scoped=true&"
import script from "./categoryTab.js?vue&type=script&lang=js&"
export * from "./categoryTab.js?vue&type=script&lang=js&"
import style0 from "./categoryTab.css?vue&type=style&index=0&id=a03ad406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ad406",
  null
  
)

export default component.exports